import React, { useMemo } from "react";

const DriverSection = ({
  register,
  watch,
  driverModes,
  filteredDrivers,
  validationErrors,
  errors,
}) => {

  const driverMode = watch("driver_mode");
  const driver = watch("driver_id");
  const DRIVER_OTHERS = {
    id: 0,
    name: 'Others',
  }

  const driverList = useMemo(() => {
    if (!driverMode) return [];

    const drivers = filteredDrivers.filter(
      v => v.driver_type === driverMode
    );

    if (driverMode === "market") {
      return [...drivers, DRIVER_OTHERS];
    }

    return drivers;

  }, [driverMode, filteredDrivers]);

  return (
    <section>
        {/* <h3 className="text-sm font-semibold mb-2">Driver Information</h3> */}
        <div className="grid md:grid-cols-3 gap-4">
          <div className="flex flex-col">
            <label className="text-xs text-gray-600 mb-1">Driver Mode</label>
            <select
              {...register("driver_mode")}
              className="border rounded p-2 text-sm w-full"
            >
              {driverModes.map((dm) => (
                <option key={dm.id} value={dm.id}>{dm.value}</option>
              ))}
            </select>
            {errors.driver_mode && (
              <p className="text-red-500 text-sm mt-1">{errors.driver_mode[0]}</p>
            )}
          </div>
          <div className="flex flex-col">
              <label className="text-xs text-gray-600 mb-1">Driver</label>
              <select {...register("driver_id")} className="border p-2 rounded text-sm">
              <option value="">Select Driver</option>
              {driverList.map((d, idx) => (
                  <option key={d.id} value={String(d.id)}>{d.name}</option>
              ))}
              </select>
              {errors.driver && (
                <p className="text-red-500 text-sm mt-1">{errors.driver[0]}</p>
              )}
          </div>
          <div className="flex flex-col">
              <label className="text-xs text-gray-600 mb-1">Driver Name</label>
              <input
              {...register("driver_name")}
              disabled={!["0"].includes(driver)}
              type="text"
              className="border rounded p-2 text-sm w-full"
              />
              {errors.driver_name && (
                <p className="text-red-500 text-sm mt-1">{errors.driver_name[0]}</p>
              )}
          </div>
          <div className="flex flex-col">
            <label className="text-xs text-gray-600 mb-1">Driver Contact</label>
            <input
              {...register("driver_contact")}
              disabled={!["0"].includes(driver)}
              type="text"
              className="border rounded p-2 text-sm w-full"
            />
            {errors.driver_contact && (
              <p className="text-red-500 text-sm mt-1">{errors.driver_contact[0]}</p>
            )}
            {validationErrors.driver_contact && (
              <p className="text-red-500 text-sm mt-1">{validationErrors.driver_contact}</p>
            )}
          </div>
        </div>
    </section>
  );
};

export default DriverSection;
